import { inject, Injectable } from '@angular/core';
import { _AuthBaseStore, AuthBaseStoreLoginModel, AuthBaseStoreProps } from '@controladad/ng-base';
import { map, of, tap } from 'rxjs';
import { AuthEntity, UserEntity } from '@repo/types';
import { AuthApiService } from '@/core';
export interface AuthStoreProp extends AuthBaseStoreProps<UserEntity> { }
export interface AuthStoreLoginModel extends AuthBaseStoreLoginModel { }

@Injectable({
  providedIn: 'root'
})
export class AuthStore extends _AuthBaseStore<AuthStoreProp, AuthStoreLoginModel> {
  private authApi = inject(AuthApiService);


  constructor() {
    super({
      loginApi: (model) => this.authApi.login({
        email: model.username,
        password: model.password,
      }).pipe(map((res) => ({
        token: res.token,
        user: {
          id: res.userId,
        }
      }))),
      meApi: () => of(undefined),
    });
  }
}
